import { Mail } from "lucide-react";
import { PageHeader } from "@/components/app/StatusBadge";
import { ContactForm } from "@/components/contact/ContactForm";
import { useApp } from "@/lib/i18n";

export default function Support() {
  const { L, brand } = useApp();
  return (
    <div className="mx-auto max-w-4xl px-4 py-8 sm:px-8" data-testid="support-page">
      <PageHeader title={L("Sokongan", "Support")} desc={L("Ada masalah atau soalan tentang pembayaran, langganan atau teknikal? Hantar mesej — kami balas dalam 1–2 hari bekerja.", "Problems or questions about payment, subscription or technical issues? Send a message — we reply within 1–2 working days.")} />
      <p className="mt-4 flex items-center gap-2 text-sm text-slate-600"><Mail size={16} className="text-violet-600" /> {L("Atau emel terus:", "Or email directly:")} <a href={`mailto:${brand.support_email}`} className="font-semibold text-violet-700" data-testid="support-email-link">{brand.support_email}</a></p>
      <div className="mt-6"><ContactForm /></div>
    </div>
  );
}
